import { formatVnd, formatVndCompact, formatVndExact } from "../format/money"

export const MoneyText = ({ value, compact = false, precise = false, align = "right" }) => {
  const full = formatVndExact(value)
  const shown = precise ? formatVnd(value, { precise: true }) : compact ? formatVndCompact(value) : formatVnd(value)
  return (
    <span
      className="ds-money"
      title={full === "—" ? undefined : full}
      style={align === "left" ? { textAlign: "left", width: "auto" } : undefined}
    >
      {shown}
    </span>
  )
}

export default MoneyText
